import { render } from "./connect-avatar.vue?vue&type=template&id=6acc813b&ts=true"
import script from "./connect-avatar.ts?vue&type=script&lang=ts&external"
export * from "./connect-avatar.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__